export default __webpack_public_path__ + "static/juanjo-jaramillo-mZnx9429i94-unsplash-9fa414f98936a1c465c50601f76ffd21.jpg";